export default __webpack_public_path__ + "static/media/mainfeature_icon2.f9cff2e0.png";